import * as types from '../mutation-types'
import { site } from 'vx/getters'
import Http from 'utils/http'

export const all = ({ dispatch }, site, query = {}) => {
	return Http.include(['dailyData.action', 'dailyData.analysis']).query(query).get(`sites/${site}/profiles`).then(response => {
		dispatch(types.SET_PROFILES, response.body.data || []);
	});
}

export const store = ({ dispatch }, site, profile) => {
	return Http.include(['dailyData.action', 'dailyData.analysis']).post(`sites/${site}/profiles`, profile).then(response => {
		dispatch(types.ADD_PROFILE, response.body.data);
		dispatch(types.SET_ACTIVE_PROFILE, response.body.data);

		return response;
	});
}

export const update = ({ dispatch }, site, profile) => {
	return Http.include(['dailyData.action', 'dailyData.analysis']).put(`sites/${site}/profiles/${profile.id}`, profile).then(response => {
		return response;
	});
}

export const destroy = ({ dispatch }, site, profile) => {
	return Http.destroy(`sites/${site}/profiles/${profile}`);
}

export const clear = ({ dispatch }) => {
	dispatch(types.SET_ACTIVE_PROFILE, {
		id: null,
		name: '',
		profile: 0,
		duration: 0,
		type: 1,
		dailyData: {
			data: []
		}
	});
}

export const edit = ({ dispatch }, profile) => {
	dispatch(types.SET_ACTIVE_PROFILE, profile);
}

export const reposition = ({ dispatch }, site, hierarchy) => {
	return Http.post(`sites/${site}/profiles/reposition`, { hierarchy }).then(response => {
		dispatch(types.SET_PROFILES, response.body.data);

		return response;
	});
}



// WEBPACK FOOTER //
// ./src/vuex/actions/profiles.js